import React from 'react';
import { ReactComponent as ArrowRight } from '../../assets/icon/arrow_right_2.svg';

interface IProps {
    direction: 'up' | 'down' | 'flat'
    vertical?: boolean
}

const TrendArrow: React.FC<IProps> = ({ direction }) => {
    const directionClassName = direction === 'up'
        ? '-rotate-45'
        : direction === 'down'
            ? 'rotate-45'
            : '';

    return <ArrowRight className={[
        'ml-[3px] inline-flex h-[9px] w-[12px] shrink-0 items-center [&_path]:stroke-current',
        directionClassName,
    ].join(' ')} />;
};

export default TrendArrow;
